export default "__VITE_ASSET__32a3c36c__"